import React from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import { ThemeProvider } from 'styled-components';

import Wrapper from '../../ui/Wrappers';
import { BREAKPOINTS } from '../../ui/settings';
import { themes } from '../../ui/design-tokens';
import { Module, Container } from './styles';

interface IProps {
  theme?: string;
  hubspot: { desktop: any; mobile: any };
}

const Banner = ({ theme, hubspot }: IProps) => {
  const vpSize = useWindowSize();
  const cleanedTheme = theme ? theme : 'white';
  return (
    <ThemeProvider theme={themes.basic[cleanedTheme]}>
      <Module>
        <Wrapper
          as={Container}
          size="mainwrapper"
          data-gtm-action={`hubspot-banner`}
          data-gtm-category="cta"
          data-gtm-event
          data-gtm-label={`hubspot-banner_${
            typeof window !== 'undefined' ? window.location.href : ''
          }`}
          dangerouslySetInnerHTML={{
            __html: vpSize.width > BREAKPOINTS.medium ? hubspot.desktop : hubspot.mobile
          }}
        />
      </Module>
    </ThemeProvider>
  );
};

export default Banner;
